import React from "react";
import JobStatusBadge from "app/components/common/JobStatusBadge";
import { formatListDate, formatListTime } from "../utils/dateFormat";

// Tablet/mobile card list (rendered by the list when not device.isDesktop, ≤1024px).
const JobsMobileCards = ({ jobs, onRowClick }) => (
  <div className="jobs-cards">
    {jobs.map((job) => (
      <button
        key={job.id}
        type="button"
        className="jobs-card"
        onClick={() => onRowClick(job.id)}
      >
        <div className="jobs-card-header">
          <div className="jobs-card-datetime">
            <span className="jobs-card-day">{formatListDate(job.date)}</span>
            <span className="jobs-card-time">
              {formatListTime(job.start_time)}
            </span>
          </div>
          <JobStatusBadge domain="inspection" value={job.inspection_status} />
        </div>
        <div className="jobs-card-address" title={job.address}>
          {job.address}
        </div>
        {job.client_name && (
          <div className="jobs-card-client">{job.client_name}</div>
        )}
        <div className="jobs-card-statuses">
          <div className="jobs-card-status">
            <span className="jobs-card-status-label">Contract</span>
            <JobStatusBadge domain="contract" value={job.contract_status} />
          </div>
          <div className="jobs-card-status">
            <span className="jobs-card-status-label">Payment</span>
            <JobStatusBadge domain="payment" value={job.payment_status} />
          </div>
          <div className="jobs-card-status">
            <span className="jobs-card-status-label">Email</span>
            <JobStatusBadge
              domain="email"
              value={job.email_aggregate?.key}
              count={job.email_aggregate?.count}
            />
          </div>
        </div>
      </button>
    ))}
  </div>
);

export default JobsMobileCards;
